import { SET_EDITING } from "../actions/editing";

export default payload => dispatch => dispatch({ type: SET_EDITING, payload });



// WEBPACK FOOTER //
// ./src/store/epics/setEditing.js